/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const WebchatIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <path d="M27.1429 5C27.6162 5 28 5.37884 28 5.84615V13.1087H26.2857V6.69231H5.71429V22.7692H13.4286V24.4615H4.85714L4.76925 24.4574C4.36603 24.4169 4.04524 24.1002 4.00419 23.7021L4 23.6154V5.84615C4 5.37884 4.38376 5 4.85714 5H27.1429Z" />
    <path d="M5.71429 9.23077H26.2857V10.9231H5.71429V9.23077Z" />
    <path d="M20.2062 22.8899L21.5714 24.4301L22.9367 22.8899H26.2857V24.5822H23.7143L21.5714 27L19.4286 24.5822H16.8571V22.8899H20.2062ZM26.2857 16H16.8571V24.5822L16.6822 24.5739C15.8176 24.4874 15.1429 23.7662 15.1429 22.8899V16C15.1429 15.0654 15.9104 14.3077 16.8571 14.3077H26.2857C27.2325 14.3077 28 15.0654 28 16V22.8899C28 23.8245 27.2325 24.5822 26.2857 24.5822V16Z" />
  </BaseIcon>
);
